import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import urlPatterns from "../../urls";
import { WINE_LIST_SLUGS, WINE_PRICE_RANGE_IDS } from "../../helpers/constants";

interface RouteProps {
  winePriceRangeId?: string;
}

interface WineListPriceRangeProps extends RouteComponentProps<RouteProps> {}

const WineListPriceRange = ({ match }: WineListPriceRangeProps) => {
  const { params } = match || {};
  const { winePriceRangeId } = params || {};

  // When we have a valid wine type id in params, we redirect to All wines with filter.
  if (winePriceRangeId) {
    const id = parseInt(winePriceRangeId, 10);
    if (Object.values(WINE_PRICE_RANGE_IDS).includes(id)) {
      return (
        <Redirect
          to={{
            pathname: urlPatterns.WINE_LIST(WINE_LIST_SLUGS.ALL_WINES),
            state: { selectedFilters: { winePriceRangeId: id } },
          }}
        />
      );
    }
  }
  return <Redirect to={urlPatterns.WINE_LIST(WINE_LIST_SLUGS.ALL_WINES)} />;
};

export default WineListPriceRange;
